import { fetchFactory } from 'isotope-client'

export const getDashboardProducts = (centerType: string) => fetchFactory(`/${centerType}/tdb`)

